import router from './router'
import store from './store'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css' 
import { Form } from 'element-ui'

NProgress.configure({ showSpinner: false }) 

const pathList = ['/','/login','/chooseUser']
router.beforeEach((to, from, next) => {
  NProgress.start()
  const userid = store.getters.userid
  const doctype = store.getters.doctype

  if(userid){
      if(doctype){
        if(pathList.indexOf(to.path) !== -1){
          if(from.path === '/studyList'){
            NProgress.done()
          }else{
            next('/studyList')
          }
        }else{
          next()
        }
      }else{
          if(from.path === '/chooseUser'){
            NProgress.done()
          }else{
            next()
        }  
    }
  }else{
    if(to.path === '/reportpdf'){
      next();
    }else if(to.path === '/login'){
      next()
    }else{
      if(from.path === '/login'){
        NProgress.done()
      }else{
        next('/login')
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
